import { TypeUserPreferenceName } from '@/lib/api/accountManager/types';

export const SMS_PREFERENCES: Array<TypeUserPreferenceName> = [
  'marketing_sms',
  'transactional_sms',
];
